import { Box, Button, Grid, Paper, Stack, Typography } from '@mui/material'
import { FunctionComponent } from 'react'
import { IconName } from '../../../shared/interfaces/icon-picker.model'
import { IconPicker } from '../display-elements-components/icon-picker'

export const DashboardInformation: FunctionComponent<{
  title: string,
  subtitle: string,
  text?: string,
  bulletPoints?: string[],
  buttonTextOne: string,
  buttonTextTwo?: string,
  icon?: IconName,
  emailAddress?: string,
}> = ({
  title,
  subtitle,
  text,
  bulletPoints,
  buttonTextOne,
  buttonTextTwo,
  icon,
  emailAddress,
}) => {
    return (
      <Grid item xs={12}>
        <Paper variant='outlined' sx={{ backgroundColor: 'primary.dark', width: '100%' }}>
          <Box sx={{ p: 4 }}>
            <Typography variant='h5' sx={{ color: 'common.white', pb: 0.75 }}>{title}</Typography>
            <Typography variant='subtitle1' sx={{ color: 'common.white' }}>{subtitle}</Typography>
            <Stack sx={{ mt: 3, mb: 4 }}>
              {bulletPoints && icon && bulletPoints.map((bulletpoint) => {
                return (
                  <Stack display='flex' alignItems='center' gap={2} flexDirection='row' sx={{ mb: 1 }}>
                    <IconPicker icon={icon} color={'common.white'} />
                    <Typography sx={{ color: 'common.white' }}>
                      {bulletpoint}
                    </Typography>
                  </Stack>
                )
              })}
            </Stack>
            <Stack display='flex' justifyContent='flex-end' gap={2} flexDirection='row'>
              {/* <Button><Typography>{buttonTextTwo}</Typography></Button> */}
              <Button rel="noopener noreferrer" href={`mailto:${emailAddress}`} sx={{
                '&:Hover': { backgroundColor: 'primary.light' }
              }}><Typography>{buttonTextOne}</Typography></Button>
            </Stack>
          </Box>
        </Paper>
      </Grid>
    )
  }

